// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3AuCT","selects":"Documents_selects__23_i8"};